import { ReactElement } from "react";
import type { IconProps } from "./iconPropsTypes";

const BellIcon = ({
  className,
  fill = "none",
  height = "24",
  width = "24"
}: IconProps): ReactElement => (
  <svg
    className={className}
    data-name="Layer 1"
    fill={fill}
    height={height}
    id="Layer_1"
    viewBox="0 0 17.75 20.76"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`.cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#fff;}`}
      </style>
    </defs>
    <title>icons_Alert</title>
    <polygon
      className="cls-1"
      points="1 15.77 1 11.82 4.24 9.06 4.24 4.47 6.31 1 11.32 1 13.39 4.47 13.39 9.06 16.75 11.82 16.75 15.77 1 15.77"
    />
    <rect className="cls-2" height="2" width="5" x="6.3" y="18.76" />
  </svg>
);

export default BellIcon;
